import React, {useEffect, useState} from "react";
import {useGlobal} from "../../Store";
import Colors from "../../Constants/Colors";
import {tokens} from "../../theme/tokens";
import avatar from "../../Assets/Images/a3.png";
import SideBarNav from "./SideBarNav";
import AuthProvider from "../Views/AuthProvider";
import {Link} from "react-router-dom";
import {useLocation} from 'react-router-dom'

const Header = props => {

    const [globalState, globalActions] = useGlobal();
    const [appName, setAppName] = useState('Pick&Drop')

    let location = useLocation();
    const [isIndex, setIsIndex] = useState(location.pathname === "/" || location.pathname === "/register");

    return (
        <div>
            {!isIndex &&
            <AuthProvider>
                <header className="site-header" style={{
                    backgroundColor: tokens.colors.crimson,
                    backgroundImage: `linear-gradient(120deg, ${tokens.colors.maroon} 0%, ${tokens.colors.crimson} 60%, ${tokens.colors.vermilion} 100%)`
                }}>
                    <div className="container-fluid">
                        <a href="#" className="site-logo-text"
                           style={{
                               backgroundColor: "rgba(23, 7, 7, 0.55)",
                               padding: 3,
                           }}
                        >
                            {appName}</a>

                        <button className="hamburger hamburger--htla">
                            <span>toggle menu</span>
                        </button>
                        <div className="site-header-content">
                            <div className="site-header-content-in">
                                <div className="site-header-shown">
                                    <div className="dropdown user-menu">
                                        <button className="dropdown-toggle" id="dd-user-menu" type="button"
                                                data-toggle="dropdown"
                                                aria-haspopup="true" aria-expanded="false">
                                            <img src={avatar} alt="" className="userPhoto"/>
                                        </button>
                                        <div className="dropdown-menu dropdown-menu-right"
                                             aria-labelledby="dd-user-menu">
                            <span className="dropdown-item userName"
                                  style={{fontWeight: 'bolder', fontSize: 'large'}}
                            >{globalState.currentUser.name}</span>
                                            <span
                                                className="dropdown-item userEmail">{globalState.currentUser.email}</span>
                                            <div className="dropdown-divider"></div>
                                            <Link className="dropdown-item" to={"/settings"}><span
                                                className="font-icon glyphicon glyphicon-cog"></span>Profile
                                                Settings</Link>
                                            <div className="dropdown-divider"></div>
                                            <a className="dropdown-item" href="#" onClick={e => {
                                                e.preventDefault();
                                                localStorage.clear();
                                                window.location.assign(process.env.PUBLIC_URL + "/");
                                            }}><span
                                                className="font-icon glyphicon glyphicon-log-out"></span>Logout</a>
                                        </div>
                                    </div>

                                    <button type="button" className="burger-right">
                                        <i className="font-icon-menu-addl"></i>
                                    </button>
                                </div>

                                <div className="mobile-menu-right-overlay"></div>
                                <div className="site-header-collapsed">
                                    <div className="site-header-collapsed-in">

                                        <div className="dropdown">
                                            <Link className="btn dropdown-toggle" id="dd-header-add" type="button"
                                                  style={{
                                                      backgroundColor: tokens.colors.ink,
                                                      border: 'none',
                                                      marginLeft: 20,
                                                      borderRadius: 999,
                                                      fontWeight: 700,
                                                      letterSpacing: '0.02em'
                                                  }} to={"/search"}>
                                                SEARCH
                                            </Link>
                                            <Link className="btn dropdown-toggle" id="dd-header-add" type="button"
                                                  style={{
                                                      backgroundColor: tokens.colors.ink,
                                                      border: 'none',
                                                      marginLeft: 20,
                                                      borderRadius: 999,
                                                      fontWeight: 700,
                                                      letterSpacing: '0.02em'
                                                  }} to={"/receive-goods"}>
                                                RECEIVE GOODS
                                            </Link>
                                            <Link className="btn dropdown-toggle" id="dd-header-add" type="button"
                                                  style={{
                                                      backgroundColor: tokens.colors.ink,
                                                      border: 'none',
                                                      marginLeft: 20,
                                                      borderRadius: 999,
                                                      fontWeight: 700,
                                                      letterSpacing: '0.02em'
                                                  }} to={"/live-map"}>
                                                LIVE MAP
                                            </Link>
                                            <Link className="btn dropdown-toggle" id="dd-header-add" type="button"
                                                  style={{
                                                      backgroundColor: tokens.colors.ink,
                                                      border: 'none',
                                                      marginLeft: 20,
                                                      borderRadius: 999,
                                                      fontWeight: 700,
                                                      letterSpacing: '0.02em'
                                                  }} to={"/requests"}>
                                                REQUESTS BOARD
                                            </Link>
                                            <Link className="btn dropdown-toggle" id="dd-header-add" type="button"
                                                  style={{
                                                      backgroundColor: tokens.colors.ink,
                                                      border: 'none',
                                                      marginLeft: 20,
                                                      borderRadius: 999,
                                                      fontWeight: 700,
                                                      letterSpacing: '0.02em'
                                                  }} to={"/reverse-timer"}>
                                                REQUEST TIMER
                                            </Link>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </header>
                <div className="mobile-menu-left-overlay"></div>

                <SideBarNav/>
            </AuthProvider>
            }
        </div>
    )
};

export default Header;
